

          
          window.Fandango.templates = window.Fandango.templates || {};
          window.Fandango.templates._noShowtimes = function anonymous(_swig,_ctx,_filters,_utils,_fn
) {
  var _imports = {};
  var _ext = _swig.extensions,
    _output = "";
_output += "<h3 class=\"theaters-module__no-theaters-title\">There are no showtimes at this cinema</h3>\n<p class=\"theaters-module__no-theaters-msg\">Try selecting another cinema to find showtimes.</p>\n";

  return _output;

}
          module.exports = window.Fandango.templates._noShowtimes;
          
          